// extracted by mini-css-extract-plugin
export default {"Link":"CarrierTrackingLink_Link__6W35a"};